import React, { FC } from 'react';

import { Award } from '../../../../../types/AwardTypes';

import {
    TrophyImageContainer,
    TrophyImage,
    TrophyRight,
    TrophyTombstone,
    TrophyName,
    TrophyDescription,
    TrophyLeft,
} from './styles';

type Prop = {
    baseAward: Award;
};

const AwardTombstone: FC<Prop> = ({ baseAward }) =>
    baseAward?.name ? (
        <TrophyTombstone>
            <TrophyLeft>
                <TrophyName>{baseAward.name}</TrophyName>
                <TrophyDescription dangerouslySetInnerHTML={{ __html: baseAward.description }} />
            </TrophyLeft>

            <TrophyRight>
                <TrophyImageContainer>
                    <TrophyImage src={baseAward.imageUrl} alt={baseAward.name} />
                </TrophyImageContainer>
            </TrophyRight>
        </TrophyTombstone>
    ) : (
        <></>
    );

export default AwardTombstone;
